import { render, staticRenderFns } from "./ProductionStorageEdit.vue?vue&type=template&id=2a700952&scoped=true&"
import script from "./ProductionStorageEdit.vue?vue&type=script&lang=js&"
export * from "./ProductionStorageEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductionStorageEdit.vue?vue&type=style&index=0&id=2a700952&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a700952",
  null
  
)

export default component.exports